import { ITranslationEntry } from '../lang';

export const AF: ITranslationEntry = {
  translations: {
    notifications: 'Kennisgewings',
    markAllAsRead: 'Merk alles as gelees',
    poweredBy: 'Aangedryf deur',
    settings: 'Instellings',
  },
  lang: 'af',
};
